import { waitForElem } from "../../utils/wait_for_elem"

/* Print button for templates/global/share_buttons.html */
waitForElem('.sei-share-print').then((elems: NodeListOf<Element>) => {
  elems.forEach((print) => {
    print.addEventListener('click', (e) => {
      e.preventDefault();
      window.print();
    });
  });
});
